import { render, staticRenderFns } from "./hukum.vue?vue&type=template&id=808f9214"
import script from "./hukum.vue?vue&type=script&lang=js"
export * from "./hukum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports